import React, { useState } from "react";
import "../../components/DashboardModule/NotVerifiedModal.css";
import logostelmart from '../../assets/images/logostelmart.png';
import { RxCross2 } from "react-icons/rx";
import VerifyAccountModal from "../VerifyAccountModal/VerifyAccountModal";

const NotVerifiedModal = ({ onClose }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (e) => {
    e.stopPropagation();
    console.log("Opening modal... current state:", isModalOpen);
    setIsModalOpen(true);
  };

  const closeModal = (e) => {
    e?.stopPropagation();
    console.log("Closing modal...");
    setIsModalOpen(false);
  };

  return (
    <div className="notModal-overlay" onClick={onClose}>
      <div className="notModal" onClick={(e) => e.stopPropagation()}>
        <button className="notModal-close" onClick={onClose}>
          <RxCross2 />
        </button>
        <img
          src={logostelmart}
          alt="Logo Stelmart"
          className="notModal-logo"
        />
        <p className="notModal-text font-poppins">
          Your account is not verified. Please
          verify your account.
        </p>
        <button
          className="notModal-button font-poppins"
          onClick={openModal}
        >
          GO TO ACCOUNT VERIFICATION
        </button>
        {isModalOpen && <VerifyAccountModal isOpen={isModalOpen} onClose={closeModal} />}
      </div>
    </div>
  );
};

export default NotVerifiedModal;